import {
  SET_ALBUM_PHOTO_BACKGROUND,
  RESET_ALBUM_PHOTO_BACKGROUNDS,
} from '../actions/album-photo-backgrounds';

const initialState = {
  printBackgrounds: {},
};

const albumPhotoBackgroundsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ALBUM_PHOTO_BACKGROUND: {
      return {
        ...state,
        printBackgrounds: {
          ...state.printBackgrounds,
          [action.photoId]: action.printBackgroundId,
        },
      };
    }

    case RESET_ALBUM_PHOTO_BACKGROUNDS:
      return {
        ...state,
        printBackgrounds: {},
      };

    default:
      return state;
  }
};

export { initialState };
export default albumPhotoBackgroundsReducer;
